import React from "react";
import { Row, Col, Drawer } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import Close from "../../../../assets/images/close-x.svg";
import { getMultilingualText } from "../../../../utils/getMultilingualText";

const SalesTypeDrawer = ({
  isSaleTypeFlag,
  setIsSaleTypeFlag,
  saleTypeData,
  tillLayout,
  searchInputRef,
  handleSelectedSaleTypeForProducts,
  handleSelectedSaleType,
}) => {
  return (
    <Drawer
      closable={false}
      placement="bottom"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "2.5vh",
            marginTop: "2vh",
            fontSize: "1vw",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              marginBottom: "1vh",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            {getMultilingualText("Select A Sales Type")}
          </p>
          <img
            src={Close}
            onClick={() => {
              setIsSaleTypeFlag(false);
              if (searchInputRef?.current) {
                searchInputRef?.current.focus();
              }
            }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      open={isSaleTypeFlag}
      className="filter"
      closeIcon={null}
      styles={{ body: { paddingBottom: 0, paddingTop: 0, backgroundColor: "#f3F4F9" } }}
      headerStyle={{borderBottom: "none" }}
      height="47vh"
      onClose={() => {
        setIsSaleTypeFlag(false);
      }}
    >
      <Scrollbars style={{ minHeight: "15vh" }}>
        <Row
          gutter={16}
          style={{
            borderRadius: "10px",
            padding: "0 1.5vw",
            fontSize: "1vw",
          }}
        >
          {saleTypeData?.map((obj, i) => (
            <Col
              // push={1}
              span={6}
              // pull={1}
              key={i}
              style={{
                padding: "2vh 2vw",
                // borderRadius: "10px",
                // marginRight: "1.5vw",
                // marginBottom: "1.5vh",
                marginTop: "1.5vh",
                cursor: "pointer",
                padding: "0 1vw",
              }}
              // onClick={handleSelectedSaleType(obj)}
              onClick={() => {
                if (tillLayout === 2) {
                  handleSelectedSaleTypeForProducts(obj)();
                } else {
                  handleSelectedSaleType(obj)();
                }
              }}
            >
              <div
                style={{
                  backgroundColor: obj?.cwrSaletype?.colourCode ? obj?.cwrSaletype?.colourCode : "#fff",
                  marginBottom: "1.5vh",
                  height: "14vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "10px",
                }}
                className="productName"
              >
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: "1.25em",
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {obj?.cwrSaletype?.name}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Scrollbars>
    </Drawer>
  );
};

export default SalesTypeDrawer;
